var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBunny3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 88,
    viewBox: "0 0 62 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 31,
    cy: 79.5455,
    rx: 31,
    ry: 8.45455,
    fill: "#4D4D4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0916 60.2643C12.3819 61.3733 10.8571 65.1623 11.8274 68.8588C12.7978 72.5554 15.8936 75.8823 16.6329 76.6678C15.2005 76.6678 14.0454 76.7602 13.2136 77.0374C11.8736 77.4533 11.2729 78.1464 11.2729 79.0705C11.3192 80.0409 12.7054 80.0409 14.8309 80.0409C16.9564 80.0409 21.2074 80.0409 21.2074 80.0409C21.2074 80.0409 25.8281 77.8691 24.026 72.8326C22.1778 67.7961 18.3888 60.2643 14.0916 60.2643Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2837 48.9435C35.2078 45.016 36.2244 42.2435 34.2837 38.9167C32.343 35.5898 19.2203 34.296 17.2796 36.4215C15.3389 38.5932 12.9824 46.5408 14.7844 53.8415C16.5865 61.1421 15.8934 64.7925 15.8934 64.7925C15.2465 67.1952 14.8768 69.5056 16.9561 72.6939C19.0355 75.8821 20.9761 77.4532 22.1313 78.1463C22.1313 78.1463 31.881 79.1166 33.7292 76.8525C35.5775 74.6345 33.3596 52.8711 34.2837 48.9435Z",
    fill: "url(#paint0_linear_3674_7674)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9777 39.3326C48.0073 37.1147 47.1756 34.2036 42.9708 29.6754C38.766 25.1471 35.0694 24.6388 33.0825 23.576C33.0825 23.576 38.5349 37.3919 38.4887 37.4843L39.5515 38.5471C43.4329 42.7981 49.486 43.9995 50.1791 42.8905C50.8259 41.7353 49.948 41.5505 48.9777 39.3326Z",
    fill: "url(#paint1_linear_3674_7674)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1088 6.61817C27.1219 -0.081827 25.6895 -1.09838 24.5343 3.29127C23.4253 7.68092 21.9005 13.6878 21.6232 16.5988C21.346 19.5099 22.5012 22.1437 23.6101 23.345L28.4157 21.6354C29.9405 17.4306 31.0956 13.3182 29.1088 6.61817Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2643 69.6443C45.8815 69.4595 47.3602 70.014 48.7464 71.0768C50.1326 72.1395 50.9181 71.8623 50.6871 73.1099C50.456 74.3574 48.9774 78.2388 45.6043 79.3016C42.6933 80.2257 41.1685 78.7471 41.1685 78.7471L44.2643 69.6443Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.644 58.7395C39.0895 58.0002 38.5812 57.3071 38.1654 56.7064C37.9344 56.383 37.7495 56.1057 37.5647 55.8285C37.4723 55.6899 37.3799 55.5513 37.2875 55.4126C35.1619 52.0395 35.2543 50.4685 35.5316 46.9568L34.9771 47.7885L29.7557 55.5513C29.7557 55.5513 30.1716 57.1685 29.2937 60.7264C25.8282 61.4195 23.1482 64.9775 23.1482 68.3044C23.1482 71.6312 24.904 76.1595 29.0626 77.2223C26.9833 77.1761 24.904 77.3147 23.3792 77.6843C21.9006 78.0078 20.884 78.4699 20.9302 79.5788C20.9302 79.8099 21.0226 79.9947 21.2075 80.1795C22.3164 81.2885 26.6599 80.7802 31.0495 80.7802C36.0399 80.7802 40.8454 80.9188 43.0171 76.2057C45.6509 70.6147 44.1261 64.7926 39.644 58.7395Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0854 78.1463L21.8081 78.0077C21.1612 78.3311 20.6992 78.8394 20.7454 79.6711C20.7454 79.856 20.7916 79.9946 20.884 80.1332H21.2074C21.115 79.9946 21.0688 79.856 21.0226 79.6711C20.9764 78.8856 21.3923 78.4698 22.0854 78.1463Z",
    fill: "url(#paint2_linear_3674_7674)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5435 63.5911L18.7118 60.8649C17.9725 58.3698 17.3256 56.4291 16.8173 53.9801C16.1242 50.5608 14.5532 43.3525 19.2663 38.085L17.8339 36.2829L17.6029 35.8208L17.418 35.4512C15.9394 36.9298 14.276 38.7319 13.2132 41.8739C12.5663 43.7222 12.1043 46.0787 12.0118 49.0822C11.827 56.5677 14.0449 59.8946 15.2925 63.2215C15.3849 63.5911 15.5236 63.9146 15.6622 64.1918C16.4939 66.0863 17.3718 67.1491 18.6194 66.2711C19.0353 65.9015 19.8208 64.8387 19.5435 63.5911Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2705 27.9657C35.3463 26.5333 33.1746 21.8202 28.7388 21.6815C24.3029 21.5429 22.7781 23.7608 21.5767 25.7477C20.3753 27.7346 19.5898 28.3353 18.065 30.1374C16.5402 31.9395 16.3553 35.0815 18.7119 37.5305C19.8208 38.6857 21.2533 39.5174 22.8243 39.887C22.9629 39.9332 23.1015 39.9332 23.2402 39.9332V39.9794C25.6429 40.1643 27.0753 39.5636 28.8312 38.2236C28.8312 38.2236 30.6332 40.2567 33.1746 40.1643C33.2208 40.1643 33.267 40.1643 33.3133 40.1643C33.9601 40.1181 34.6995 39.9794 35.4388 39.7484C38.9967 38.5008 39.3663 36.4215 39.505 34.296C39.5974 32.2167 37.1946 29.3981 36.2705 27.9657Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8777 37.3919L29.9405 36.6063C30.1253 36.4677 30.1715 36.1905 30.0329 36.0057C29.8943 35.8208 29.617 35.7746 29.4322 35.9132L28.5543 36.5601L27.5839 35.9595C27.3991 35.8208 27.1219 35.9132 26.9832 36.0981C26.8446 36.2829 26.937 36.5601 27.1219 36.6988L28.3232 37.4381C28.5081 37.4381 28.7391 37.4843 28.8777 37.3919Z",
    fill: "#4D4D4D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.379 32.1244C23.379 32.6789 23.0556 33.0947 22.6397 33.0947C22.2238 33.0947 21.9004 32.6789 21.9004 32.1244C21.9004 31.5699 22.2238 31.1541 22.6397 31.1541C23.0556 31.1541 23.379 31.5699 23.379 32.1244Z",
    fill: "#4D4D4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4684 32.1244C34.4684 32.6789 34.1449 33.0947 33.7291 33.0947C33.3132 33.0947 32.9897 32.6789 32.9897 32.1244C32.9897 31.5699 33.3132 31.1541 33.7291 31.1541C34.1449 31.1541 34.4684 31.5699 34.4684 32.1244Z",
    fill: "#4D4D4D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5776 39.7025C35.5776 39.7025 32.1121 40.0722 32.1583 40.2108C33.7755 46.5873 26.9831 51.8549 24.4417 54.6273C23.0093 56.1521 19.6362 59.7563 18.7121 64.5156C18.25 66.7797 20.1907 68.8128 22.5472 64.6542C24.95 60.4032 28.5541 57.3073 32.2045 52.8253C35.8086 48.3432 37.01 44.3694 35.5776 39.7025Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7582 66.0403C18.6196 65.5783 18.5733 65.07 18.6658 64.4693C18.8044 63.7762 18.9892 63.1293 19.174 62.5286L19.0354 62.1128C18.7582 62.8521 18.5271 63.6376 18.3885 64.4231C18.2499 65.07 18.2961 65.7169 18.5271 66.2252C18.5734 66.2252 18.712 66.1328 18.7582 66.0403Z",
    fill: "url(#paint3_linear_3674_7674)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1049 21.9124C24.4415 19.1862 23.5173 14.7503 24.1642 10.2221C24.8111 5.6938 25.6891 3.75311 26.2898 3.75311C26.8905 3.75311 27.4911 4.86208 27.907 6.84898C28.2767 8.83587 28.7849 11.3772 27.907 15.4434C27.0291 19.5559 26.4746 19.6021 26.1049 21.9124Z",
    fill: "#F22E6C",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3674_7674",
    x1: 24.7655,
    y1: 35.3844,
    x2: 24.7655,
    y2: 78.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3674_7674",
    x1: 41.7418,
    y1: 23.576,
    x2: 41.7418,
    y2: 43.2801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3674_7674",
    x1: 21.4138,
    y1: 78.0077,
    x2: 21.4138,
    y2: 80.1332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3674_7674",
    x1: 18.7423,
    y1: 62.1128,
    x2: 18.7423,
    y2: 66.2252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBunny3);
export default __webpack_public_path__ + "static/media/bunny-3.65e1d4635773db7f1a92c34682a9470d.svg";
export { ForwardRef as ReactComponent };